import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'

export default {
  getSBIforTeam (teamId) {
    var target = urls.SEASON_BREAK_INFOS_URL + '?team=' + teamId.toString()
    return Vue.http.get(target)
  },
  deleteSBI (id) {
    let target = urls.SEASON_BREAK_INFOS_URL + id + '/'
    return Vue.http.delete(target, {'headers': authHeaders.getAuthHeaders()})
  },
  createCustomTeamSBI (datas) {
    let target = urls.CUSTOM_TEAM_SBI_URL
    return Vue.http.post(target, datas, {'headers': authHeaders.getAuthHeaders()})
  },
  updateCustomTeamSBI (datas) {
    let target = urls.CUSTOM_TEAM_SBI_URL + datas.id + '/'
    return Vue.http.patch(target, datas, {'headers': authHeaders.getAuthHeaders()})
  },
  updateCustomPlayerSBI (datas) {
    let target = urls.CUSTOM_PLAYER_SBI_URL
    return Vue.http.patch(target, datas, {'headers': authHeaders.getAuthHeaders()})
  }

}



// WEBPACK FOOTER //
// ./src/api/real-api/season-break-infos.api.js